import React from "react";
import LegalLayout from "../../components/layout/LegalLayout";

const ContactPage: React.FC = () => (
  <LegalLayout>
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-8">
        <h1 className="text-3xl font-bold text-blue-700 mb-6">Contact Us</h1>
        <p className="text-gray-700 mb-4">
          Have a question, need support, or want to give feedback? Reach out to the TyreLink team.
        </p>
        <div className="mt-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Email</h2>
          <p className="text-gray-700 mb-4">
            <a href="mailto:support@tyrelink.app" className="text-blue-600 hover:underline">
              support@tyrelink.app
            </a>
          </p>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Phone</h2>
          <p className="text-gray-700 mb-4">
            <a href="https://wa.me/27686247270" className="text-blue-600 hover:underline">
              WhatsApp: +27 68 624 7270
            </a>
          </p>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Business Hours</h2>
          <p className="text-gray-700 mb-4">
            Monday – Friday: 8:00am – 5:00pm<br />
            Saturday: 9:00am – 1:00pm<br />
            Sunday & Public Holidays: Closed
          </p>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Registered Address</h2>
          <p className="text-gray-700 mb-4">
            TyreLink (Pty) Ltd<br />
            123 Main Road<br />
            Johannesburg, 2000<br />
            South Africa
          </p>
        </div>
        <p className="text-gray-500 mt-8 text-sm">
          For privacy or POPIA requests, email: <a href="mailto:support@tyrelink.app" className="text-blue-600 hover:underline">support@tyrelink.app</a>
        </p>
      </div>
    </div>
  </LegalLayout>
);

export default ContactPage;